import React, { useEffect, useRef } from "react";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import CardSection from "../../../../../../components/ui/card/CardSection";
import { useContractDepartmentMakeNonBillableMutation, useLazyGetContractDepartmentsWithoutInvoiceScheduleQuery } from "../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../services/toastService/ToastService";
import SwalAlert from "../../../../../../services/swalService/SwalService";

const ContractWithoutSchedule = () => {

  const gridRef = useRef();
  const [gridData, setGridData] = React.useState([]);
  const { confirm } = SwalAlert();

  /* API call */
  const [getContractDepartmentsWithoutInvoiceSchedule, {
    isFetching: isContractUpcomingInvoicesFetching,
    isSuccess: isContractUpcomingInvoicesFetched,
    data: ContractUpcomingInvoicesData,
  },] = useLazyGetContractDepartmentsWithoutInvoiceScheduleQuery();

  const [contractDepartmentMakeNonBillable, {
    isSuccess: iscontractDepartmentMakeNonBillableSuccess,
    data: addcontractDepartmentMakeNonBillableData
  }] = useContractDepartmentMakeNonBillableMutation();

  useEffect(() => {
    if (iscontractDepartmentMakeNonBillableSuccess && addcontractDepartmentMakeNonBillableData) {
      ToastService.success(addcontractDepartmentMakeNonBillableData?.errorMessage);
      getContractDepartmentsWithoutInvoiceSchedule();
    }
  }, [iscontractDepartmentMakeNonBillableSuccess, addcontractDepartmentMakeNonBillableData]);

  useEffect(() => {
    getContractDepartmentsWithoutInvoiceSchedule();
  }, []);

  useEffect(() => {
    if(!isContractUpcomingInvoicesFetching && isContractUpcomingInvoicesFetched && ContractUpcomingInvoicesData){
      setGridData(ContractUpcomingInvoicesData);
    }
  }, [isContractUpcomingInvoicesFetching, isContractUpcomingInvoicesFetched, ContractUpcomingInvoicesData]);

  const rowClass = (rowData) => {
    return {
      'red-color-row': rowData?.outstandingBalance > 0,
      'blueviolet-color-row': rowData?.outstandingBalance < 0,
      'black-color-row': rowData?.outstandingBalance === 0,
    };
  };
  
const getCtxMenuItems = (row) => {
  if(!row) { return []; } 
  return [
    {
      label: "View Contract",
      command: () => {
        window.open(`/EditContracts?contract=${row?.lContractKey}`);
      },
    },
    {
      label: "Non-Billable",
      command: () => {
      confirm('Are you sure you want to','Make This Department Non-Billable?','Yes','No').then((confirmed) => {
        if (confirmed) {
          const req = {
            plContractDepartmentKey: row?.lContractDepartmentKey,
          };
          contractDepartmentMakeNonBillable(req);
        }
      });
      },
    },
  ];
}


  return (
    <>
      <CardSection>
        <div className="contract-without-schedule-detail">
          <MolGrid
            value={gridData}
            ref={gridRef}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            ctxMenuItems={getCtxMenuItems}
            rowClassName={rowClass}
            resizableColumns
          >
            <Column
              field="sContractType"
              header="Contract Type"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="lContractKey"
              header="Contract Key"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="sContractName1"
              header="Contract"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "25%" }}
              grouping
              sortable
            />
            <Column
              field="sClientName1"
              header="Client"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "20%" }}
              grouping
              sortable
            />
            <Column
              field="sDepartmentName"
              header="Department"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "10%" }}
              grouping
              sortable
            />
            <Column
              field="nCost"
              header="Cost"
              bodyStyle={{ textAlign: "right" }}
              style={{ width: "10%" }}
              colType="money"
              grouping
              sortable
            />
            <Column
              field="previouslyInvoiced"
              header="Invoiced"
              bodyStyle={{ textAlign: "right" }}
              style={{ width: "8%" }}
              colType="money"
              grouping
              sortable
            />
            <Column
              field="outstandingBalance"
              header="Balance"
              bodyStyle={{ textAlign: "Right" }}
              style={{ width: "7%" }}
              colType="money"
              grouping
              sortable
            />
          </MolGrid>
        </div>
      </CardSection>
    </>
  );
};

export default ContractWithoutSchedule;
